import {useState, useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {clearStatus} from '../../../admin-configuration/state/admin-configuration-slice';
import {
    showErrorStatus,
} from '../../../security/state/user-slice';
import {RootState} from '../../../shared/state/root-reducer';
import {AppDispatch} from '../../../shared/state/store';
// import {
//     Estimate,
// } from '../../../admissions-advisor/models/estimator';
import {Utils} from '../../../shared/utils';
import _ from 'lodash';
import {
    createSelectedEstimate,
    saveSelectedEstimate,
    saveSelectedEstimateSelfPay,
    loadSavedEstimatesListv3,
    createSelectedEstimateSelfPay
} from '../../../shared/state/estimator-thunk';
import {
    Estimate as NewEstimate,
    FacilityLevelOfCare,
    QuoteMethod,
    FacilityLevelOfCareWithCrossoverDays,
    CrossoverSelectionEnum,
    Id,
    SummarySelections,
    VobClassification,
    
} from '@finpay-estimation/estimation-types';
import {admissionsAdvisorUtils} from '../../../admissions-advisor/utils/admission-advisor-utils';

import {
    VobClassificationUpdate,
    DialogActionButton,
    isCrossoverTriggered,
    getDaysBetweenAdmissionAndPolicyEndDates,
    NewLOCModalV3,
} from '@finpay-development/shared-components';
import {
    saveSelectedVob,
} from '../../../shared/state/vob-thunk';
import { Vob } from '@finpay-estimation/estimation-types';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from '@mui/material';
import {FormikProps} from 'formik';
import {AdmissionDate} from '../../../admissions-advisor/components/pfr-estimator/admission-date';
import { isSelfPayPayor, normalizeDescription } from '../../../shared/utils/insurance-utils';

interface EstLevelOfCareModalProps {
    open: boolean;
    clientId: Id | undefined;
    facilityId: Id | undefined;
    facilityName: string | undefined;
    quoteMethod: string | QuoteMethod;
    admissionDate: string | Date;
    facilityLevelsOfCareList: FacilityLevelOfCare[];
    handleEstimatorLevelOfCareModalClose: () => void;
    promptUserToUpdateModalForCrossover?: boolean
    isV3?: boolean
}

export const stringToQuoteMethod = (quoteMethod: string): QuoteMethod => {
    switch (quoteMethod) {
        case 'sca':
            return QuoteMethod.SCA;
        case 'avglos':
            return QuoteMethod.AVGLOS;
        case 'manual':
            return QuoteMethod.MANUAL;
        case 'rlos':
            return QuoteMethod.RLOS;
        default:
            return QuoteMethod.AVGLOS;
    }
};

export const quoteMethodToString = (quoteMethod: QuoteMethod): string => {
    switch (quoteMethod) {
        case QuoteMethod.SCA:
            return 'sca';
        case QuoteMethod.AVGLOS:
            return 'avglos';
        case QuoteMethod.MANUAL:
            return 'manual';
        case QuoteMethod.RLOS:
            return 'rlos';
        default:
            return 'avglos';
    }
};

export const quoteMethodToDisplayString = (quoteMethod: QuoteMethod | string): string => {
    
    switch (quoteMethod) {
        case 'sca':
        case QuoteMethod.SCA:
            return 'Single Case Agreement';
        case 'avglos':
        case QuoteMethod.AVGLOS:
            return 'Average Length of Stay';
        case 'rlos':
        case QuoteMethod.RLOS:
            return 'Recommended Length of Stay';
        case 'manual':
        case QuoteMethod.MANUAL:
            return 'Manual';
        default:
            return 'Average Length of Stay';
    }
}


const compareFunction = (prevValue: any, nextValue: any) =>
    _.isEqual(prevValue, nextValue);

export function EstimatorLevelOfCareModal({
    open,
    clientId,
    facilityId,
    facilityName,
    quoteMethod,
    admissionDate,
    facilityLevelsOfCareList,
    handleEstimatorLevelOfCareModalClose,
    promptUserToUpdateModalForCrossover,
}: EstLevelOfCareModalProps) {
    const state = {
        saveStatus: useSelector(
            (state: RootState) =>
                state.adminContext.adminConfigurationContext.modalSaveStatus
        ),
        errorMessage: useSelector(
            (state: RootState) =>
                state.adminContext.adminConfigurationContext.errorMessage
        ),
        vob: useSelector(
            (state: RootState) => state.vobContext.selectedVob as any
        ),
        rateAsPayorPlan: useSelector(
            (state: RootState) => state.estimatorContext.rateAsPayorPlan
        ),
        vobPatientState: useSelector(
            (state: RootState) =>
                state.admissionsAdvisorContext.vobPatientContext
        ),
        patient: useSelector(
            (state: RootState) => state.patientContext.selectedPatient
        ),
        masterLevelsOfCareState: useSelector(
            (state: RootState) =>
                state.adminContext.adminConfigurationContext?.levelsOfCare,
            compareFunction
        ),
        isLoadingMasterLoc: useSelector(
            (state: RootState) =>
                state.admissionsAdvisorContext.estimatorContext.isLoading
                    .isLoadingMasterLoc
        ),
        getClientLOCStatus: useSelector(
            (state: RootState) =>
                state.admissionsAdvisorContext.estimatorContext.isLoading
                    .getClientLOCStatus
        ),
        isLoadingClientLoc: useSelector(
            (state: RootState) =>
                state.admissionsAdvisorContext.estimatorContext.isLoading
                    .isLoadingClientLoc
        ),
        configGetLOCStatus: useSelector(
            (state: RootState) =>
                state.admissionsAdvisorContext.estimatorContext.isLoading
                    .configGetLOCStatus
        ),
        clientLevelsOfCareState: useSelector((state: RootState) => {
            // TODO: use reselect memoization package to memoize this selector so that
            // this looping doesn't happen over and over again
            const masterLOCs =
                state.adminContext.adminConfigurationContext?.levelsOfCare;

            if (masterLOCs.length > 0) {
                return state.admissionsAdvisorContext.estimatorContext?.clientLevelsOfCare.map(
                    (loc: any) => {
                        // double O(n) time complexity
                        // consider sorting master list by id, then binary search
                        // performance improvement: O(n) -> O(log n)
                        const matchingLoc: any = masterLOCs.find(
                            (cfgLoc: any) => {
                                return (
                                    cfgLoc.levelOfCareId ===
                                    loc.cfgLevelOfCareId
                                );
                            }
                        );

                        return {
                            ...loc,
                            cfgLocType: matchingLoc?.locType || 0,
                        };
                    }
                );
            } else {
                return state.admissionsAdvisorContext.estimatorContext
                    ?.clientLevelsOfCare;
            }
        }),
        estimate: useSelector((state: RootState) => {
            return state.estimatorContext.selectedEstimate;
        }),
        vobClassifications: useSelector(
            (state: RootState) =>
                state.vobContext.vobClassifications
        ),
        selectedPatient: useSelector(
            (state: RootState) =>
                state.patientContext.selectedPatient
        ),
        payersMap: useSelector(
            (state: RootState) =>
                state.adminContext.adminConfigurationContext.payersMap
        ),
        selectedPatientCurrentInsurance: useSelector(
            (state: RootState) =>
                state.patientContext.selectedPatientCurrentInsurance
        ),
        selectedEncounter: useSelector(
            (state: RootState) =>
                state.patientContext.selectedEncounter
        ),
    };

    const {
        saveStatus,
        errorMessage,
        vob,
        rateAsPayorPlan,
        vobPatientState,
        estimate,
        vobClassifications,
        selectedPatient,
        payersMap,
        selectedPatientCurrentInsurance,
        selectedEncounter
    } = state;

    const [modalFormik, setModalFormik] = useState<FormikProps<any> | null>(
        null
    );

    // Check if patient has self-pay insurance
    const isSelfPay = useMemo(() => {
        return isSelfPayPayor(selectedPatientCurrentInsurance?.payorId, payersMap);
    }, [selectedPatientCurrentInsurance?.payorId, payersMap]);

    const newQuoteMethod =
        typeof quoteMethod === 'string'
            ? stringToQuoteMethod(quoteMethod)
            : (quoteMethod as QuoteMethod);

    const [anticipatedAdmissionDate, setAnticipatedAdmissionDate] = useState(admissionDate ? new Date(admissionDate) : new Date())

    useEffect(() => {
        if (admissionDate) {
            const parsedDate = admissionDate instanceof Date 
                ? admissionDate 
                : new Date(admissionDate);
            if (!isNaN(parsedDate.getTime())) {
                setAnticipatedAdmissionDate(parsedDate);
            }
        }
    }, [admissionDate, open]);

    const paramId = -2;
    const dispatch = useDispatch<AppDispatch>();

    // Check if rateAsPayorPlan is null and show error toast
    useEffect(() => {
        if (open && !rateAsPayorPlan) {
            dispatch(showErrorStatus('Rate as payer plan information is missing. Please check VOB.'));
        }
    }, [open, rateAsPayorPlan, dispatch]);

    async function handleSave(
        selectedLocs: FacilityLevelOfCare[],
        vobClassificationUpdates: Record<string, VobClassificationUpdate>
    ) {
        const formikErrorMsg = getFormikErrMsg(modalFormik?.errors)

        if(formikErrorMsg){
            dispatch(showErrorStatus(formikErrorMsg))
            return
        }

        // Check if rateAsPayorPlan is null before proceeding
        if (!rateAsPayorPlan) {
            dispatch(showErrorStatus('Rate as payer plan information is missing. Please check VOB.'));
            return;
        }


        const { facilityPayorName: _payorName, ...payorRest } = rateAsPayorPlan.payor ?? {};
        const { facilityPlanName: _planName, ...planRest } = rateAsPayorPlan.plan ?? {};
        const rateAsPayorPlanForApi = {
            ...rateAsPayorPlan,
            payor: rateAsPayorPlan.payor ? payorRest : rateAsPayorPlan.payor,
            plan: rateAsPayorPlan.plan ? planRest : rateAsPayorPlan.plan,
        };

        selectedLocs.sort((a: FacilityLevelOfCare, b: FacilityLevelOfCare) => a.sortOrder - b.sortOrder)

        if(
            //User got message after changing admission date from outside the modal
            promptUserToUpdateModalForCrossover &&
            vob && vob.policyEndDate &&
            //If the user changed admission date inside the modal, it might have disabled crossover. So need to double-check
            ((!isSelfPay && !estimate?.isPrivatePay) &&
                isCrossoverTriggered({
                    selectedLocs: selectedLocs as FacilityLevelOfCareWithCrossoverDays[],
                    policyEndDate: new Date(vob.policyEndDate),
                    admissionDate: anticipatedAdmissionDate,
                })) &&
            //For cases where user did not interact with the modal form at all
            !modalFormik?.dirty
        ){

            /**
             * Throwing error for when the user goes in the modal
             * after being prompted to update Days Before Crossover,
             * but tries to save right away without updating anything.
             * */

            if(
                admissionsAdvisorUtils.doLocsHaveUndefinedCrossoverValues(
                    selectedLocs as FacilityLevelOfCareWithCrossoverDays[])
            ){
                dispatch(showErrorStatus('Days Before Crossover must be at least 0 days'))
                return
            }

            if(
                vob && vob.policyEndDate &&
                admissionsAdvisorUtils.isSelectedBeforeCrossoverDayGreaterThanTotal({
                    selectedLocs:  selectedLocs as FacilityLevelOfCareWithCrossoverDays[],
                    policyEndDate: new Date(vob.policyEndDate),
                    admissionDate: anticipatedAdmissionDate
                })
            ){
                dispatch(showErrorStatus('The total Days Before Crossover must not exceed the available limit'))
                return
            }
        }

        const vobUpdateKeys = Object.keys(vobClassificationUpdates);
        const vobNeedsUpdate = vobUpdateKeys.length > 0;
        const inNetwork: boolean = rateAsPayorPlan.payor?.inNetwork!;

        if (vobNeedsUpdate) {
            const vobCopy: Vob = Utils.deepClone(vob);

            const inNetwVobClassifications =
                vobCopy.innClassifications || [];

            const ooNetwVobClassifications =
                vobCopy.oonClassifications || [];

            vobUpdateKeys.forEach(key => {
                const {
                    toggleButtonSelection,
                    coPay,
                    coInsurance,
                    maxDays,
                    vobClassification,
                } = vobClassificationUpdates[key];
                let coPaySelection;

                switch (toggleButtonSelection) {
                    case 0:
                        coPaySelection = 'copayonly';
                        break;
                    case 1:
                        coPaySelection = 'n';
                        break;
                    case 2:
                        coPaySelection = 'y';
                        break;
                    default:
                        coPaySelection = 'copayonly';
                        break;
                }

                if (inNetwork) {
                    inNetwVobClassifications.push({
                        vobClassificationId:
                        vobClassification.vobClassificationId,
                        vobClassificationName: key,
                        vobClassificationDesc: key,
                        isInpatient: vobClassification.isInpatient ?? undefined,
                        coInsurance: coInsurance ?? undefined,
                        coPay: coPay ?? undefined,
                        maxDays: maxDays ?? undefined,
                        copayType: coPaySelection
                    });
                } else {
                    ooNetwVobClassifications.push({
                        vobClassificationId: vobClassification.vobClassificationId,
                        vobClassificationName: key,
                        vobClassificationDesc: key,
                        isInpatient: vobClassification.isInpatient ?? undefined,
                        coInsurance: coInsurance ?? undefined,
                        coPay: coPay ?? undefined,
                        maxDays: maxDays ?? undefined,
                        copayType: coPaySelection
                    });
                }
            });

            await dispatch(saveSelectedVob({
                vobId: vob.vobId, 
                vob: vobCopy 
            }));
        }

        const isPlanYearCrossover = selectedLocs.some((loc: FacilityLevelOfCare) => {
            const crossoverLoc = loc as FacilityLevelOfCareWithCrossoverDays;
            return (
                Boolean(crossoverLoc.losDaysAfterCrossover) ||
                Boolean(crossoverLoc.losDaysBeforeCrossover)
            );
        });

        const createdDate = admissionsAdvisorUtils.formatDateTime(new Date());
        const levelsOfCare = selectedLocs
            ?.map((loc: FacilityLevelOfCare) => loc.facilityLevelOfCareName)
            .join(', ');

        const estimateDescription = `${levelsOfCare} - ${createdDate}`;

        const estimateCopy = Utils.deepClone(estimate);
        if (estimate?.estimateId) {
            const {
                priorCareSummary,
                summary,
                crossOverSummary,
                estimateId,
                createUserId,
                createDt,
                lastUpdateUserId,
                lastUpdateDt,
                ...estimatePutBody
            } = estimateCopy;

            const {
                advisorPatientId, 
                ...cleanedEstimatePutBody
            } = estimatePutBody;

            const putEstimateBody: NewEstimate = {
                ...cleanedEstimatePutBody,
                patientId: selectedPatient.patientId,
                isPlanYearCrossover,
                quoteMethod: newQuoteMethod,
                anticipatedAdmitDate: anticipatedAdmissionDate,
                facilityLevelOfCare: selectedLocs,
                summarySelection: estimateCopy?.summarySelection || SummarySelections.NONADJUSTED,
                crossoverSelection:
                estimateCopy?.crossoverSelection ||
                CrossoverSelectionEnum.WITH, // default
                rateAsPayorPlan: rateAsPayorPlanForApi,
                isSelfPay: isSelfPay,
                isPrivatePay: estimate?.isPrivatePay,
                description: normalizeDescription(estimateDescription, estimateCopy?.isPrivatePay, isSelfPay),
            };
            const createAction = (isSelfPay || estimate?.isPrivatePay) ? saveSelectedEstimateSelfPay : saveSelectedEstimate;
            await dispatch(createAction({estimate: putEstimateBody, estimateId}));
        } else {
            const postEstimateBody: NewEstimate = {
                vobId: vob.vobId!,
                clientId: clientId!,
                facilityId: facilityId!,
                advisorPatientId: vobPatientState.patient.advisorPatientId!,
                patientId: selectedPatient.patientId,
                ...((selectedEncounter?.patientEncounterId || estimateCopy?.patientEncounterId) && { 
                    patientEncounterId: selectedEncounter?.patientEncounterId || estimateCopy?.patientEncounterId 
                }),
                description: normalizeDescription(estimateDescription, estimateCopy?.isPrivatePay, isSelfPay),
                quoteMethod: newQuoteMethod,
                anticipatedAdmitDate: anticipatedAdmissionDate,
                facilityLevelOfCare: selectedLocs,
                isPlanYearCrossover: isPlanYearCrossover,
                summarySelection: SummarySelections.NONADJUSTED,
                crossoverSelection:
                    estimateCopy?.crossoverSelection ||
                    CrossoverSelectionEnum.WITH, // default
                isActive: true,
                rateAsPayorPlan: rateAsPayorPlanForApi,
                isSelfPay: isSelfPay,
                isPrivatePay: estimate?.isPrivatePay,
            };
            const createAction = (isSelfPay || estimate?.isPrivatePay) ? createSelectedEstimateSelfPay : createSelectedEstimate;
            await dispatch(createAction(postEstimateBody));
        }
        
        if (vob?.vobId) {
            await dispatch(loadSavedEstimatesListv3({
                paramId: -2,
                patientId: Number(selectedPatient?.patientId),
            }));
        }
        
        handleLocModalCallback(true);
    }

    function handleLocModalCallback(saveSuccessful: boolean | undefined) {
        if (saveSuccessful || typeof saveSuccessful === 'undefined') {
            handleEstimatorLevelOfCareModalClose();
        } else {
            dispatch(showErrorStatus(errorMessage));
        }
        dispatch(clearStatus());
    }

    const handleCancelCallback = () => {
        handleEstimatorLevelOfCareModalClose();
    };

    const initialListOfSelectedLocSynced = useMemo(() => {
        const selected = estimate?.facilityLevelOfCare as FacilityLevelOfCareWithCrossoverDays[] | undefined;
        if (!selected?.length || !facilityLevelsOfCareList?.length) return selected ?? [];
        return selected.map((loc) => {
            const fromList = facilityLevelsOfCareList.find(
                (l) => l.facilityLevelOfCareId === loc.facilityLevelOfCareId
                    || l.levelOfCareId === loc.facilityLevelOfCareId
            );
            if (!fromList) return loc;
            return {
                ...loc,
                losDays: fromList.losDays ?? loc.losDays,
                recommendedLos: fromList.recommendedLos ?? loc.recommendedLos,
            };
        }) as FacilityLevelOfCareWithCrossoverDays[];
    }, [estimate?.facilityLevelOfCare, facilityLevelsOfCareList]);

    const isEdit = estimate?.facilityLevelOfCare && estimate?.facilityLevelOfCare?.length > 0
    return (
        <>
            <Dialog
                className="modal"
                open={open}
                fullWidth={true}
                maxWidth="lg"
                scroll="body"
            >
                <DialogTitle>{isEdit ? 'Edit' : 'Add'} Levels of Care</DialogTitle>
                <DialogContent>
                    <Grid container direction="row">
                        <Grid item xs={3} sm={3}>
                            <AdmissionDate
                                admissionDate={anticipatedAdmissionDate}
                        onChangeHandler={(date)=>{
                            setAnticipatedAdmissionDate(new Date(date))
                                }}
                            />
                        </Grid>
                        {/* <Grid item xs={4} sm={4}>
                            <TextField
                                select
                                label="Quote Method"
                                name="quoteMethod"
                                value={quoteMethodSelection}
                                className='state-field'
                                onChange={(e: any) => {
                                    handleQuoteMethodChange(e.target.value)
                                }}
                                onBlur={() =>{}}
                            >
                                <MenuItem value={QuoteMethod.AVGLOS}>Average Length of Stay</MenuItem>
                                <MenuItem value={QuoteMethod.RLOS}>Recommended Length of Stay</MenuItem>
                                <MenuItem value={QuoteMethod.MANUAL}>Manual</MenuItem>
                                <MenuItem value={QuoteMethod.SCA}>Single Case Agreement</MenuItem>
                            </TextField>
                        </Grid> */}
                    </Grid>
                    {
                        vob && vob.policyEndDate && !estimate?.isPrivatePay && !isSelfPay && isCrossoverTriggered({
                            selectedLocs: modalFormik?.values?.selectedLocs || [],
                            admissionDate: anticipatedAdmissionDate,
                            policyEndDate: new Date(vob.policyEndDate)
                        }) && (
                            (()=>{
                                return (
                                    <Typography sx={{marginY: '1rem'}}>
                                        Total Days Before Crossover : {getDaysBetweenAdmissionAndPolicyEndDates({
                                        admissionDate: anticipatedAdmissionDate,
                                        policyEndDate: new Date(vob.policyEndDate)
                                    })} day(s)
                                    </Typography>
                                )
                            })()

                        )
                    }
                    {rateAsPayorPlan && vob && vob.policyEndDate ? (
                        <NewLOCModalV3
                            quoteMethod={newQuoteMethod}
                            initialListOfSelectedLoc={initialListOfSelectedLocSynced}
                            listOfLoc={facilityLevelsOfCareList}
                            admissionDate={anticipatedAdmissionDate}
                            policyEndDate={new Date(vob.policyEndDate)}
                            vob={vob}
                            rateAsPayorPlan={rateAsPayorPlan}
                            vobClassifications={[]}
                            getFormikValues={(formik: any) => {
                                setModalFormik(formik as FormikProps<any>);
                            }}
                            enableCrossover={!(estimate?.isPrivatePay || isSelfPay)}
                        />
                    ) : (
                        <Typography color="error" sx={{marginY: '1rem'}}>
                            {!rateAsPayorPlan 
                                ? "Rate as payer plan information is missing. Please check VOB before continuing."
                                : "VOB policy end date is missing. Please check VOB data before continuing."
                            }
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions
                    test-id="estimator-loc-modal-dialog-actions"
                >
                    <DialogActionButton
                        isEnabled={true}
                        savebuttonText="Save"
                        saveStatus={saveStatus}
                        spinnerLeftPosition={5}
                        executeSave={async () => {
                            if (!rateAsPayorPlan) {
                                dispatch(showErrorStatus('Payor plan information is missing. Please select a valid payor plan.'));
                                return;
                            }
                            await handleSave(
                                modalFormik?.values.selectedLocs,
                                modalFormik?.values.vobClassificationUpdates
                            );
                        }}
                        handleCallbackSave={handleLocModalCallback}
                        handleCallbackCancel={handleCancelCallback}
                    />
                </DialogActions>
            </Dialog>
        </>
    );
}

export function getFormikErrMsg (formikError?: Record<string, any> | any[] | null): string | undefined {

    if(!formikError) return

    if(!Array.isArray(formikError) && Object.values(formikError).length > 0) {

        if (typeof Object.values(formikError)?.[0] === 'string') {
            return Object.values(formikError)?.[0]
        } else {
            return getFormikErrMsg(Object.values(formikError)?.[0])
        }
    }

    if(Array.isArray(formikError)){

        const filteredFormikError = formikError.filter((formError: any)=> {
            if(!_.isNil(formError))
                return formError
        })

        return getFormikErrMsg(filteredFormikError[0])
    }

    return
}
